import React, { FC, useState } from 'react'
import { makeStyles, Theme, Grid, Typography } from '@material-ui/core'
import Slider, { Settings as SliderSettings } from 'react-slick'
import { Link, useRouteMatch } from 'react-router-dom'

import { IDemo } from 'types'

interface MobileDemosProps {
  title: string
  bodyText: string
  demos?: IDemo[]
}

export const MobileDemos: FC<MobileDemosProps> = ({ title, bodyText, demos }) => {
  const classes = useStyles()
  const { path } = useRouteMatch()
  const [counter, setCounter] = useState<number>(1)

  const sliderSettings: SliderSettings = {
    infinite: false,
    swipeToSlide: true,
    speed: 500,
    centerPadding: '60px',
    variableWidth: true,
    arrows: false,
    adaptiveHeight: true,
    afterChange: (index: number) => {
      setCounter(index + 1)
    }
  }
  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant='h1' className={classes.heading}>
            {title}
          </Typography>
          <Typography paragraph>{bodyText}</Typography>
        </Grid>
        <Grid item container xs={12}>
          <Grid item xs={12}>
            <Slider {...sliderSettings}>
              {demos &&
                demos.map(demo => (
                  <Link to={`${path}/${demo.id}`}>
                    <div className={classes.sliderItem} style={{ backgroundImage: `url(${demo.monolith})` }}></div>
                  </Link>
                ))}
            </Slider>
          </Grid>
          <Grid container item xs={12} justify='flex-end'>
            <Grid item>
              <Typography className={classes.paginationCounter} variant='h4' component='span'>
                {counter} / {demos && demos.length}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: '2rem'
  },
  heading: {
    marginBottom: '1rem'
  },
  sliderItem: {
    marginRight: '1rem',
    minWidth: 'calc(9/16 * 370px)',
    minHeight: 370,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat'
  },
  paginationCounter: {
    marginTop: '1rem'
  },
  monolith: {
    width: 270,
    height: 370
  }
}))
